/* =============================================
   Infinite Scroll — Shopify Dawn 15.3
   Bug-free, tested against actual DOM structure
   ============================================= */
(function () {
  'use strict';

  var ioObserver  = null; /* IntersectionObserver ref for cleanup */
  var mutObserver = null; /* MutationObserver ref for cleanup */

  /* ── Core: find next page URL from real pagination DOM ── */
  function getNextUrl() {
    /* Current page = aria-disabled="true" + pagination__item--current */
    var currentEl = document.querySelector('.pagination__item--current[aria-disabled="true"]');
    if (!currentEl) return null;

    /* Get current page number from its href or text */
    var currentHref = currentEl.getAttribute('href') || '';
    var currentMatch = currentHref.match(/[?&]page=(\d+)/);
    var currentNum = currentMatch ? parseInt(currentMatch[1]) : null;

    /* If no href (page 1 has no href sometimes) — use text content */
    if (!currentNum) {
      currentNum = parseInt(currentEl.textContent.trim());
    }
    if (!currentNum || isNaN(currentNum)) return null;

    var nextNum = currentNum + 1;

    /* Find link with page=nextNum in pagination */
    var links = document.querySelectorAll('.pagination a[href]');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href');
      if (!href) continue;
      var m = href.match(/[?&]page=(\d+)/);
      if (m && parseInt(m[1]) === nextNum) {
        /* Return absolute URL */
        return links[i].href;
      }
    }

    return null;
  }

  /* ── Cleanup previous init ── */
  function cleanup() {
    if (ioObserver)  { ioObserver.disconnect();  ioObserver  = null; }
    var el;
    el = document.querySelector('.prasha-inf-loader');   if (el) el.remove();
    el = document.querySelector('.prasha-inf-sentinel'); if (el) el.remove();
    var pw = document.querySelector('.pagination');
    if (pw) pw.style.display = '';
  }

  /* ── Main init ── */
  function init() {
    cleanup();

    var productGrid    = document.querySelector('#product-grid');
    var paginationWrap = document.querySelector('.pagination');

    if (!productGrid || !paginationWrap) return;

    var nextUrl = getNextUrl();
    if (!nextUrl) return; /* No next page — stop */

    var loading      = false;
    var loadedUrls   = {}; /* Track loaded URLs — prevent duplicates */

    /* Hide pagination */
    paginationWrap.style.display = 'none';

    /* Loader dots */
    var loader = document.createElement('div');
    loader.className = 'prasha-inf-loader';
    loader.innerHTML = '<span></span><span></span><span></span>';
    loader.style.cssText = 'display:none;justify-content:center;align-items:center;gap:6px;padding:32px 0;';
    paginationWrap.insertAdjacentElement('afterend', loader);

    /* Sentinel — 1px trigger element */
    var sentinel = document.createElement('div');
    sentinel.className = 'prasha-inf-sentinel';
    sentinel.style.cssText = 'height:1px;width:100%;display:block;';
    loader.insertAdjacentElement('afterend', sentinel);

    function showLoader(v) {
      loader.style.display = v ? 'flex' : 'none';
    }

    function loadMore() {
      if (!nextUrl || loading) return;
      if (loadedUrls[nextUrl]) { nextUrl = null; return; } /* Duplicate guard */

      loading = true;
      loadedUrls[nextUrl] = true;
      showLoader(true);

      var fetchUrl = nextUrl;

      fetch(fetchUrl)
        .then(function(res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');

          /* Append new grid items */
          var newGrid = doc.querySelector('#product-grid');
          if (!newGrid) { nextUrl = null; return; }

          var newItems = Array.from(newGrid.querySelectorAll('.grid__item'));
          if (newItems.length === 0) { nextUrl = null; return; }

          newItems.forEach(function(item) {
            item.style.opacity    = '0';
            item.style.transform  = 'translateY(12px)';
            item.style.transition = 'opacity 0.35s ease, transform 0.35s ease';
            productGrid.appendChild(item);
          });

          /* Fade in after paint */
          requestAnimationFrame(function() {
            setTimeout(function() {
              newItems.forEach(function(item) {
                item.style.opacity   = '1';
                item.style.transform = 'translateY(0)';
              });
            }, 30);
          });

          /* Update pagination HTML — so getNextUrl reads correct current page */
          var newPagination = doc.querySelector('.pagination');
          if (newPagination) {
            paginationWrap.innerHTML = newPagination.innerHTML;
            paginationWrap.style.display = 'none';
            nextUrl = getNextUrl(); /* Re-evaluate next URL */
          } else {
            nextUrl = null; /* Last page reached */
          }
        })
        .catch(function(err) {
          console.error('[InfScroll]', err);
          nextUrl = null;
          paginationWrap.style.display = ''; /* Show pagination as fallback */
        })
        .finally(function() {
          loading = false;
          showLoader(false);

          /* Chain: if sentinel still in viewport after load, trigger again */
          if (nextUrl) {
            setTimeout(function() {
              var r = sentinel.getBoundingClientRect();
              if (r.top < window.innerHeight + 200) loadMore();
            }, 300);
          }
        });
    }

    /* IntersectionObserver */
    ioObserver = new IntersectionObserver(function(entries) {
      if (entries[0].isIntersecting && nextUrl && !loading) {
        loadMore();
      }
    }, { rootMargin: '0px 0px 300px 0px' });

    ioObserver.observe(sentinel);
  }

  /* ── Watch for filter/sort AJAX updates ── */
  function watchFilters() {
    var container = document.querySelector('#ProductGridContainer');
    if (!container) return;

    mutObserver = new MutationObserver(function() {
      /* Debounce — wait for Dawn to finish rendering */
      clearTimeout(mutObserver._timer);
      mutObserver._timer = setTimeout(function() {
        init();
      }, 700);
    });

    mutObserver.observe(container, { childList: true, subtree: false });
  }

  /* ── Bootstrap ── */
  function start() {
    init();
    watchFilters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(start, 800); });
  } else {
    setTimeout(start, 800);
  }

})();